import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { Cancel01Icon } from "@hugeicons/core-free-icons/index";
import { HugeiconsIcon } from "@hugeicons/react";
import { Divider, Flex } from "antd";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";

export const SelectStickyAction = (props) => {
  const {
    selectedCount,
    handleClearSelectionClick,
    handleSubmitSelected,
    modalProps,
    okButtonText,
    disabled = false,
    pending = false,
  } = props;
  const {
    showClearSelectionConfirm,
    setShowClearSelectionConfirm,
    handleConfirmClearSelection,
  } = modalProps;

  const { t, i18n } = useTranslation();
  const { getLocalizedNumber } = useLocalizedText();
  return (
    <>
      {selectedCount > 0 && (
        <div className="sticky-bottom" style={{ bottom: 0 }}>
          <Flex
            justify="flex-start"
            align="center"
            style={{
              gap: "2px",
              position: "absolute",
              bottom: "72px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 2000,
              padding: "8px",
              borderRadius: "16px",
              border: "1px solid #E5E4E2",
              background: "white",
            }}
          >
            <Button
              variant="ghost"
              style={{
                color: "#6B6A61",
                border: "none",
                background: "transparent",
                textWrap: "nowrap",
              }}
              className="btn-sm"
              onClick={handleClearSelectionClick}
              disabled={disabled}
            >
              <HugeiconsIcon
                icon={Cancel01Icon}
                style={{ color: "#7A4819" }}
                size={16}
              />
              <span className="ms-2">
                {t("SELECTED_PILGRIMS_COUNT", {
                  count:
                    i18n.language === "ae"
                      ? getLocalizedNumber(String(selectedCount))
                      : selectedCount,
                })}
              </span>
            </Button>

            <Divider
              type="vertical"
              style={{ height: "24px", margin: "0 8px" }}
            />

            <Button
              className="btn-primary btn-sm"
              onClick={handleSubmitSelected}
              disabled={selectedCount === 0 || pending || disabled}
              style={{ textWrap: "nowrap" }}
            >
              {okButtonText}
              {pending && <Spinner size="sm" className="ms-2" />}
            </Button>
          </Flex>
        </div>
      )}

      {/* Clear Selection Confirmation Modal */}
      <BootstrapModal
        show={showClearSelectionConfirm}
        onHide={() => setShowClearSelectionConfirm(false)}
        centered
      >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>
            {t("CONFIRM_CLEAR_SELECTION")}
          </BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          <p>{t("SELECTION_WILL_BE_LOST")}</p>
        </BootstrapModal.Body>
        <BootstrapModal.Footer>
          <Button
            disabled={disabled}
            variant="secondary"
            onClick={() => setShowClearSelectionConfirm(false)}
          >
            {t("CANCEL")}
          </Button>
          <Button disabled={disabled} variant="danger" onClick={handleConfirmClearSelection}>
            {t("CONFIRM")}
          </Button>
        </BootstrapModal.Footer>
      </BootstrapModal>
    </>
  );
};
